// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: robot_syncer/bulk.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ConfigValue } from "../config/api/config_service";
import { Empty } from "../google/protobuf/empty";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "carbon.robot_syncer.bulk";

export enum Outcome {
  OUTCOME_UNSPECIFIED = 0,
  SUCCESS = 1,
  FAILURE = 2,
  UNRECOGNIZED = -1,
}

export function outcomeFromJSON(object: any): Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNSPECIFIED":
      return Outcome.OUTCOME_UNSPECIFIED;
    case 1:
    case "SUCCESS":
      return Outcome.SUCCESS;
    case 2:
    case "FAILURE":
      return Outcome.FAILURE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Outcome.UNRECOGNIZED;
  }
}

export function outcomeToJSON(object: Outcome): string {
  switch (object) {
    case Outcome.OUTCOME_UNSPECIFIED:
      return "OUTCOME_UNSPECIFIED";
    case Outcome.SUCCESS:
      return "SUCCESS";
    case Outcome.FAILURE:
      return "FAILURE";
    case Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface BulkEditRequest {
  /**
   * Auth0 ID of the calling user, to appear in audit logs: e.g.,
   * "google_oauth2|12345".
   */
  userId: string;
  /** Update timestamp to use for all writes in this request. */
  timestamp:
    | string
    | undefined;
  /** Reason is the optional reason for this change. */
  reason: string;
  /**
   * Serials of robots to edit. The same set of operations will be applied to
   * every listed robot.
   */
  serials: string[];
  /** Edit operations to apply to each listed robot. */
  operations: Operation[];
}

/**
 * An operation on one or more config nodes. The given action will be applied
 * to all keys that match the key spec. For instance, the key spec could select
 * "the `enabled` attribute of all cameras across all rows", and the action
 * could be "set value to `true`".
 */
export interface Operation {
  keySpec: KeySpec | undefined;
  action: Action | undefined;
}

export interface Action {
  set?: SetAction | undefined;
  add?: AddAction | undefined;
  remove?: RemoveAction | undefined;
}

/** Set the value of an existing leaf node. */
export interface SetAction {
  /**
   * The desired new value for the node. (The `value.timestamp_ms` field is
   * ignored.)
   */
  value: ConfigValue | undefined;
}

/** Add a child to a list node. */
export interface AddAction {
  /** Name of child node, as in `config.proto.AddToListRequest`. */
  name: string;
}

/** Remove a child from a list node. */
export interface RemoveAction {
  /** Name of child node to remove. */
  name: string;
}

/**
 * A `KeySpec` describes a pattern to select config keys. Each component of the
 * key spec describes how to descend one level* in the config tree. A component
 * can be deterministic, if it has a single literal string (e.g., "common",
 * "cameras"), or nondeterministic, if it has multiple literals and/or wildcard
 * patterns (e.g., "target*", or "row1, row2, and row3").
 *
 * Example: to select all predict cameras on a Slayer:
 *
 *      # {row1,row2,row3}/cv/cameras/predict* /auto_brightness_enabled
 *      key_spec {
 *        components {
 *          branches { literal: "row1" }
 *          branches { literal: "row2" }
 *          branches { literal: "row3" }
 *        }
 *        components { branches { literal: "cv" } }
 *        components { branches { literal: "cameras" } }
 *        components { branches { wildcard { prefix: "predict" } } }
 *        components { branches { literal: "auto_brightness_enabled" } }
 *      }
 *
 * Example: to select all scanners on a Reaper:
 *
 *      # rows/* /aimbot/scanners/* /enabled
 *      key_spec {
 *        components { branches { literal: "rows" } }
 *        components { branches { wildcard {} } }
 *        components { branches { literal: "aimbot" } }
 *        components { branches { literal: "scanners" } }
 *        components { branches { wildcard {} } }
 *        components { branches { literal: "enabled" } }
 *      }
 *
 * * Except for the `all_rows` special case, which may descend two levels.
 */
export interface KeySpec {
  components: KeyComponent[];
}

export interface KeyComponent {
  branches: ComponentBranch[];
}

export interface ComponentBranch {
  literal?: string | undefined;
  wildcard?:
    | Pattern
    | undefined;
  /**
   * Special case for either `rows/*` or `{row1,row2,row3}` depending on what
   * children are available, to support both Slayers and Reapers.
   *
   * Note that this branch allows a component to descend either one or two
   * levels, whereas most forms descend exactly one level.
   */
  allRows?: Empty | undefined;
}

/**
 * A glob of the form "{prefix}*{suffix}". This matches any string that starts
 * with `prefix`, ends with `suffix`, and is at least as long as `len(prefix) +
 * len(suffix)`. In particular, the empty pattern matches every string.
 */
export interface Pattern {
  prefix: string;
  suffix: string;
}

export interface BulkEditResponse {
  robots: RobotEditRecord[];
}

/** Record of edits that succeeded or failed for a particular robot. */
export interface RobotEditRecord {
  serial: string;
  records: EditRecord[];
  /**
   * Top-level informational or error message for issues associated with the
   * robot itself rather than any particular key (e.g., if no config exists for
   * the robot).
   */
  message: string;
}

/** Record of an attempted edit to a single config node. */
export interface EditRecord {
  key: string;
  action: Action | undefined;
  outcome: Outcome;
  message: string;
}

export interface RestoreToVersionRequest {
  serial: string;
  copyFromSerial: string;
  timestamp:
    | string
    | undefined;
  /** Reason is the optional reason for this restore. */
  reason: string;
}

function createBaseBulkEditRequest(): BulkEditRequest {
  return { userId: "", timestamp: undefined, reason: "", serials: [], operations: [] };
}

export const BulkEditRequest: MessageFns<BulkEditRequest> = {
  encode(message: BulkEditRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(18).fork()).join();
    }
    if (message.reason !== "") {
      writer.uint32(42).string(message.reason);
    }
    for (const v of message.serials) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.operations) {
      Operation.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BulkEditRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkEditRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serials.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.operations.push(Operation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkEditRequest {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : undefined,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
      serials: globalThis.Array.isArray(object?.serials) ? object.serials.map((e: any) => globalThis.String(e)) : [],
      operations: globalThis.Array.isArray(object?.operations)
        ? object.operations.map((e: any) => Operation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BulkEditRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    if (message.serials?.length) {
      obj.serials = message.serials;
    }
    if (message.operations?.length) {
      obj.operations = message.operations.map((e) => Operation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkEditRequest>, I>>(base?: I): BulkEditRequest {
    return BulkEditRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkEditRequest>, I>>(object: I): BulkEditRequest {
    const message = createBaseBulkEditRequest();
    message.userId = object.userId ?? "";
    message.timestamp = object.timestamp ?? undefined;
    message.reason = object.reason ?? "";
    message.serials = object.serials?.map((e) => e) || [];
    message.operations = object.operations?.map((e) => Operation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOperation(): Operation {
  return { keySpec: undefined, action: undefined };
}

export const Operation: MessageFns<Operation> = {
  encode(message: Operation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.keySpec !== undefined) {
      KeySpec.encode(message.keySpec, writer.uint32(10).fork()).join();
    }
    if (message.action !== undefined) {
      Action.encode(message.action, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Operation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOperation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.keySpec = KeySpec.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.action = Action.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Operation {
    return {
      keySpec: isSet(object.keySpec)
        ? KeySpec.fromJSON(object.keySpec)
        : isSet(object.key_spec)
        ? KeySpec.fromJSON(object.key_spec)
        : undefined,
      action: isSet(object.action) ? Action.fromJSON(object.action) : undefined,
    };
  },

  toJSON(message: Operation): unknown {
    const obj: any = {};
    if (message.keySpec !== undefined) {
      obj.keySpec = KeySpec.toJSON(message.keySpec);
    }
    if (message.action !== undefined) {
      obj.action = Action.toJSON(message.action);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Operation>, I>>(base?: I): Operation {
    return Operation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Operation>, I>>(object: I): Operation {
    const message = createBaseOperation();
    message.keySpec = (object.keySpec !== undefined && object.keySpec !== null)
      ? KeySpec.fromPartial(object.keySpec)
      : undefined;
    message.action = (object.action !== undefined && object.action !== null)
      ? Action.fromPartial(object.action)
      : undefined;
    return message;
  },
};

function createBaseAction(): Action {
  return { set: undefined, add: undefined, remove: undefined };
}

export const Action: MessageFns<Action> = {
  encode(message: Action, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.set !== undefined) {
      SetAction.encode(message.set, writer.uint32(10).fork()).join();
    }
    if (message.add !== undefined) {
      AddAction.encode(message.add, writer.uint32(18).fork()).join();
    }
    if (message.remove !== undefined) {
      RemoveAction.encode(message.remove, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Action {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.set = SetAction.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.add = AddAction.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.remove = RemoveAction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Action {
    return {
      set: isSet(object.set) ? SetAction.fromJSON(object.set) : undefined,
      add: isSet(object.add) ? AddAction.fromJSON(object.add) : undefined,
      remove: isSet(object.remove) ? RemoveAction.fromJSON(object.remove) : undefined,
    };
  },

  toJSON(message: Action): unknown {
    const obj: any = {};
    if (message.set !== undefined) {
      obj.set = SetAction.toJSON(message.set);
    }
    if (message.add !== undefined) {
      obj.add = AddAction.toJSON(message.add);
    }
    if (message.remove !== undefined) {
      obj.remove = RemoveAction.toJSON(message.remove);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Action>, I>>(base?: I): Action {
    return Action.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Action>, I>>(object: I): Action {
    const message = createBaseAction();
    message.set = (object.set !== undefined && object.set !== null) ? SetAction.fromPartial(object.set) : undefined;
    message.add = (object.add !== undefined && object.add !== null) ? AddAction.fromPartial(object.add) : undefined;
    message.remove = (object.remove !== undefined && object.remove !== null)
      ? RemoveAction.fromPartial(object.remove)
      : undefined;
    return message;
  },
};

function createBaseSetAction(): SetAction {
  return { value: undefined };
}

export const SetAction: MessageFns<SetAction> = {
  encode(message: SetAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== undefined) {
      ConfigValue.encode(message.value, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = ConfigValue.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetAction {
    return { value: isSet(object.value) ? ConfigValue.fromJSON(object.value) : undefined };
  },

  toJSON(message: SetAction): unknown {
    const obj: any = {};
    if (message.value !== undefined) {
      obj.value = ConfigValue.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetAction>, I>>(base?: I): SetAction {
    return SetAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetAction>, I>>(object: I): SetAction {
    const message = createBaseSetAction();
    message.value = (object.value !== undefined && object.value !== null)
      ? ConfigValue.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseAddAction(): AddAction {
  return { name: "" };
}

export const AddAction: MessageFns<AddAction> = {
  encode(message: AddAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddAction {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: AddAction): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddAction>, I>>(base?: I): AddAction {
    return AddAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddAction>, I>>(object: I): AddAction {
    const message = createBaseAddAction();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseRemoveAction(): RemoveAction {
  return { name: "" };
}

export const RemoveAction: MessageFns<RemoveAction> = {
  encode(message: RemoveAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveAction {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: RemoveAction): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveAction>, I>>(base?: I): RemoveAction {
    return RemoveAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveAction>, I>>(object: I): RemoveAction {
    const message = createBaseRemoveAction();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseKeySpec(): KeySpec {
  return { components: [] };
}

export const KeySpec: MessageFns<KeySpec> = {
  encode(message: KeySpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.components) {
      KeyComponent.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeySpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeySpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.components.push(KeyComponent.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeySpec {
    return {
      components: globalThis.Array.isArray(object?.components)
        ? object.components.map((e: any) => KeyComponent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: KeySpec): unknown {
    const obj: any = {};
    if (message.components?.length) {
      obj.components = message.components.map((e) => KeyComponent.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeySpec>, I>>(base?: I): KeySpec {
    return KeySpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeySpec>, I>>(object: I): KeySpec {
    const message = createBaseKeySpec();
    message.components = object.components?.map((e) => KeyComponent.fromPartial(e)) || [];
    return message;
  },
};

function createBaseKeyComponent(): KeyComponent {
  return { branches: [] };
}

export const KeyComponent: MessageFns<KeyComponent> = {
  encode(message: KeyComponent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.branches) {
      ComponentBranch.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyComponent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.branches.push(ComponentBranch.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyComponent {
    return {
      branches: globalThis.Array.isArray(object?.branches)
        ? object.branches.map((e: any) => ComponentBranch.fromJSON(e))
        : [],
    };
  },

  toJSON(message: KeyComponent): unknown {
    const obj: any = {};
    if (message.branches?.length) {
      obj.branches = message.branches.map((e) => ComponentBranch.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyComponent>, I>>(base?: I): KeyComponent {
    return KeyComponent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyComponent>, I>>(object: I): KeyComponent {
    const message = createBaseKeyComponent();
    message.branches = object.branches?.map((e) => ComponentBranch.fromPartial(e)) || [];
    return message;
  },
};

function createBaseComponentBranch(): ComponentBranch {
  return { literal: undefined, wildcard: undefined, allRows: undefined };
}

export const ComponentBranch: MessageFns<ComponentBranch> = {
  encode(message: ComponentBranch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.literal !== undefined) {
      writer.uint32(10).string(message.literal);
    }
    if (message.wildcard !== undefined) {
      Pattern.encode(message.wildcard, writer.uint32(18).fork()).join();
    }
    if (message.allRows !== undefined) {
      Empty.encode(message.allRows, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComponentBranch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComponentBranch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.literal = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.wildcard = Pattern.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.allRows = Empty.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComponentBranch {
    return {
      literal: isSet(object.literal) ? globalThis.String(object.literal) : undefined,
      wildcard: isSet(object.wildcard) ? Pattern.fromJSON(object.wildcard) : undefined,
      allRows: isSet(object.allRows)
        ? Empty.fromJSON(object.allRows)
        : isSet(object.all_rows)
        ? Empty.fromJSON(object.all_rows)
        : undefined,
    };
  },

  toJSON(message: ComponentBranch): unknown {
    const obj: any = {};
    if (message.literal !== undefined) {
      obj.literal = message.literal;
    }
    if (message.wildcard !== undefined) {
      obj.wildcard = Pattern.toJSON(message.wildcard);
    }
    if (message.allRows !== undefined) {
      obj.allRows = Empty.toJSON(message.allRows);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComponentBranch>, I>>(base?: I): ComponentBranch {
    return ComponentBranch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComponentBranch>, I>>(object: I): ComponentBranch {
    const message = createBaseComponentBranch();
    message.literal = object.literal ?? undefined;
    message.wildcard = (object.wildcard !== undefined && object.wildcard !== null)
      ? Pattern.fromPartial(object.wildcard)
      : undefined;
    message.allRows = (object.allRows !== undefined && object.allRows !== null)
      ? Empty.fromPartial(object.allRows)
      : undefined;
    return message;
  },
};

function createBasePattern(): Pattern {
  return { prefix: "", suffix: "" };
}

export const Pattern: MessageFns<Pattern> = {
  encode(message: Pattern, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prefix !== "") {
      writer.uint32(10).string(message.prefix);
    }
    if (message.suffix !== "") {
      writer.uint32(18).string(message.suffix);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pattern {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePattern();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prefix = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.suffix = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Pattern {
    return {
      prefix: isSet(object.prefix) ? globalThis.String(object.prefix) : "",
      suffix: isSet(object.suffix) ? globalThis.String(object.suffix) : "",
    };
  },

  toJSON(message: Pattern): unknown {
    const obj: any = {};
    if (message.prefix !== "") {
      obj.prefix = message.prefix;
    }
    if (message.suffix !== "") {
      obj.suffix = message.suffix;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Pattern>, I>>(base?: I): Pattern {
    return Pattern.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Pattern>, I>>(object: I): Pattern {
    const message = createBasePattern();
    message.prefix = object.prefix ?? "";
    message.suffix = object.suffix ?? "";
    return message;
  },
};

function createBaseBulkEditResponse(): BulkEditResponse {
  return { robots: [] };
}

export const BulkEditResponse: MessageFns<BulkEditResponse> = {
  encode(message: BulkEditResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.robots) {
      RobotEditRecord.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BulkEditResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkEditResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robots.push(RobotEditRecord.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkEditResponse {
    return {
      robots: globalThis.Array.isArray(object?.robots)
        ? object.robots.map((e: any) => RobotEditRecord.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BulkEditResponse): unknown {
    const obj: any = {};
    if (message.robots?.length) {
      obj.robots = message.robots.map((e) => RobotEditRecord.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkEditResponse>, I>>(base?: I): BulkEditResponse {
    return BulkEditResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkEditResponse>, I>>(object: I): BulkEditResponse {
    const message = createBaseBulkEditResponse();
    message.robots = object.robots?.map((e) => RobotEditRecord.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRobotEditRecord(): RobotEditRecord {
  return { serial: "", records: [], message: "" };
}

export const RobotEditRecord: MessageFns<RobotEditRecord> = {
  encode(message: RobotEditRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serial !== "") {
      writer.uint32(10).string(message.serial);
    }
    for (const v of message.records) {
      EditRecord.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotEditRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotEditRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.records.push(EditRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotEditRecord {
    return {
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      records: globalThis.Array.isArray(object?.records) ? object.records.map((e: any) => EditRecord.fromJSON(e)) : [],
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: RobotEditRecord): unknown {
    const obj: any = {};
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.records?.length) {
      obj.records = message.records.map((e) => EditRecord.toJSON(e));
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotEditRecord>, I>>(base?: I): RobotEditRecord {
    return RobotEditRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotEditRecord>, I>>(object: I): RobotEditRecord {
    const message = createBaseRobotEditRecord();
    message.serial = object.serial ?? "";
    message.records = object.records?.map((e) => EditRecord.fromPartial(e)) || [];
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseEditRecord(): EditRecord {
  return { key: "", action: undefined, outcome: 0, message: "" };
}

export const EditRecord: MessageFns<EditRecord> = {
  encode(message: EditRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.action !== undefined) {
      Action.encode(message.action, writer.uint32(18).fork()).join();
    }
    if (message.outcome !== 0) {
      writer.uint32(24).int32(message.outcome);
    }
    if (message.message !== "") {
      writer.uint32(34).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EditRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.action = Action.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditRecord {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      action: isSet(object.action) ? Action.fromJSON(object.action) : undefined,
      outcome: isSet(object.outcome) ? outcomeFromJSON(object.outcome) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: EditRecord): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.action !== undefined) {
      obj.action = Action.toJSON(message.action);
    }
    if (message.outcome !== 0) {
      obj.outcome = outcomeToJSON(message.outcome);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditRecord>, I>>(base?: I): EditRecord {
    return EditRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditRecord>, I>>(object: I): EditRecord {
    const message = createBaseEditRecord();
    message.key = object.key ?? "";
    message.action = (object.action !== undefined && object.action !== null)
      ? Action.fromPartial(object.action)
      : undefined;
    message.outcome = object.outcome ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseRestoreToVersionRequest(): RestoreToVersionRequest {
  return { serial: "", copyFromSerial: "", timestamp: undefined, reason: "" };
}

export const RestoreToVersionRequest: MessageFns<RestoreToVersionRequest> = {
  encode(message: RestoreToVersionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serial !== "") {
      writer.uint32(10).string(message.serial);
    }
    if (message.copyFromSerial !== "") {
      writer.uint32(18).string(message.copyFromSerial);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(26).fork()).join();
    }
    if (message.reason !== "") {
      writer.uint32(34).string(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreToVersionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreToVersionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.copyFromSerial = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreToVersionRequest {
    return {
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      copyFromSerial: isSet(object.copyFromSerial)
        ? globalThis.String(object.copyFromSerial)
        : isSet(object.copy_from_serial)
        ? globalThis.String(object.copy_from_serial)
        : "",
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : undefined,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: RestoreToVersionRequest): unknown {
    const obj: any = {};
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.copyFromSerial !== "") {
      obj.copyFromSerial = message.copyFromSerial;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestoreToVersionRequest>, I>>(base?: I): RestoreToVersionRequest {
    return RestoreToVersionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestoreToVersionRequest>, I>>(object: I): RestoreToVersionRequest {
    const message = createBaseRestoreToVersionRequest();
    message.serial = object.serial ?? "";
    message.copyFromSerial = object.copyFromSerial ?? "";
    message.timestamp = object.timestamp ?? undefined;
    message.reason = object.reason ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
